import $ from 'jquery';
// export for others scripts to use
window.jQuery = $;
window.jquery = $;
window.$ = $;
import whatInput from 'what-input';
import Foundation from 'foundation-sites';
import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper';
import ImageCompare from "image-compare-viewer";

// configure Swiper modules
Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

//import 'cookie-consent.js';

document.addEventListener('DOMContentLoaded', function(event) {
	
	// Load Zurb Foundation
	// 
	// -----------------------
	
	// Foundation
	jQuery(document).foundation();
	
	//------------------------------------------------------------*/
	//
	// Credits

    //Displays in the browser console, the corresponding credits to Modern Talking.
    let args = ['\n %c Designed and developed by Modern Talking \u00A9 https://moderntalking.es \n',
        'background: #1d1d1d; padding:10px 0;color: #ffffff;'];

    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1)
        window.console.log.apply(console, args);

    else if (window.console)
        window.console.log('Designed and developed by Modern Talking - https://moderntalking.es');	
	
	// Header
	// 
	// -----------------------
	
	// Hamburguer menu
	const headerElements = {
		logo: 			document.querySelector('.site-title'),
		hamburguer: document.querySelector('.menu-toggle'),
		menu: 			document.querySelector('.main-navigation')
	}
	
	headerElements.hamburguer.onclick = function() {
		// Looping through headerElements object	
		const singleHeaderElement = Object.keys(headerElements)
		for (let value of singleHeaderElement) {
			headerElements[value].classList.toggle('is-active');
		}
	}
	
	// Add class to header on scroll
	window.onscroll = function changeClass(){
	 
		var scrollPosY = window.pageYOffset | document.body.scrollTop,
				mastHead 	 = document.querySelector('#masthead'),
				phone 		 = document.querySelector('.site-header__phone');
		
		if(scrollPosY > window.innerHeight) {
			mastHead.classList.add('shrink-header');
			phone.classList.add('is-active');
			
		} else if(scrollPosY <= window.innerHeight) {
			mastHead.classList.remove('shrink-header');
			phone.classList.remove('is-active');
			
		}
	}
	
	// Front page
	// 
	// -----------------------
	
	// Testimonial home slider
	var swiper = new Swiper(".testimonial-home-slider", {
	  slidesPerView: 1,
	  spaceBetween: 10,
	  pagination: {
	    el: ".swiper-pagination",
	    clickable: true,
	  },
	  autoplay: {
	    delay: 6000,
	    disableOnInteraction: false,
	  },
	  breakpoints: {
	    768: {
	      slidesPerView: 2,
	      spaceBetween: 40,
	    },
	    1200: {
	      slidesPerView: 3,
	      spaceBetween: 80,
	    }
	  },
	  
	  // Navigation arrows
	  navigation: {
	    nextEl: '.testimonial-button-next',
	    prevEl: '.testimonial-button-prev',
	  }
	});
	
	// Blocks
	// 
	// -----------------------
	
	// Header hero slider
	var swiper = new Swiper(".block__hero-swiper", {
	  slidesPerView: 1,
	  autoplay: {
	    delay: 6000,
	    disableOnInteraction: false,
	  },
	  
	  // Navigation arrows
	  navigation: {
	    nextEl: '.block__hero-swiper-button-next',
	    prevEl: '.block__hero-swiper-button-prev',
	  }
	});
	
	// Before after slider
	var swiper = new Swiper(".before-after-swiper", {
	  slidesPerView: 1,
	  allowTouchMove: false,
	  
	  pagination: {
      el: ".before-after-swiper-pagination",
      clickable: true,
    },
	});
	
	// Before - After comparsion
	const currentLang = document.documentElement.lang;
	
	if (currentLang == 'es') {
		var beforeText = 'Antes de la cirugía',
				afterText = 'Después de la cirugía';
	}
	
	else {
		var beforeText = 'Before surgery',
				afterText = 'After surgery';
	}
	
	// https://image-compare-viewer.netlify.app/
	const viewers = document.querySelectorAll(".image-compare");
	
	const options = {

	  // UI Theme Defaults
	  controlColor: "#f5f5f5",
	  controlShadow: true,
	  addCircle: true,
	  addCircleBlur: true,
	
	  // Label Defaults
	  showLabels: true,
	  labelOptions: {
	    before: beforeText,
	    after: afterText,
	    onHover: true
	  },
	
	  // Smoothing
	  smoothing: true,
	  smoothingAmount: 100,
	
	  // Other options
	  hoverStart: false,
	  verticalMode: false,
	  startingPoint: 50,
	  fluidMode: false
	};

	viewers.forEach((element) => {
	  let view = new ImageCompare(element, options).mount();
	});	

});
